// extracted by mini-css-extract-plugin
module.exports = {"sectionContent":"styles_sectionContent__2FyjC","mediaWrapper":"styles_mediaWrapper__XrtEb","image":"styles_image__tAhcu","list":"styles_list__gOU_P","item":"styles_item__WebyW"};